import React from "react";

export default function IndonesiaFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-ind61{fill:#ce1124}.cls-ind62{fill:#d8cbcb}.cls-ind63{fill:#bc0416}.cls-ind64{fill:#e21d27}.cls-ind65{fill:#eae4e4}"
            }
          </style>
        </defs>
        <path
          d="M1515.73 1698.21H484.27c-59.86 0-108.57-48.7-108.57-108.57V410.36c0-59.86 48.7-108.57 108.57-108.57h1031.47c59.86 0 108.57 48.7 108.57 108.57v1179.29c0 59.86-48.7 108.57-108.57 108.57ZM484.27 327.47c-45.7 0-82.89 37.18-82.89 82.89v1179.29c0 45.7 37.18 82.89 82.89 82.89h1031.47c45.7 0 82.89-37.18 82.89-82.89V410.36c0-45.7-37.18-82.89-82.89-82.89H484.27Z"
          className="cls-ind63"
        />
        <path
          d="M1238.64 342c4.05 17.91 9.06 31.87 13 41.51 0 0 2.34 5.74 16.48 36.06-31.84 8.19-55.68 9.41-72.15 8.84-12.49-.43-28.37-2.16-44.01 6.92-10.25 5.95-14.73 13.24-17.69 11.89-4.61-2.11-.21-22.72 9.83-39.87 10.04-17.14 23.44-26.94 35.81-35.8 12.24-8.77 31.73-20.7 58.73-29.55Z"
          className="cls-ind64"
        />
        <path
          d="M1151.96 435.33c15.64-9.08 31.52-7.35 44.01-6.92 16.46.57 40.3-.66 72.15-8.84-14.14-30.32-16.48-36.06-16.48-36.06-3.94-9.64-8.95-23.6-13-41.51-.29.1-.57.19-.86.29-4.27 7.27-9.32 18.25-9.77 31.62-.47 14.02 4.52 18.28 1.09 23.33-8.54 12.56-44.42-6.61-70.38 7.65-15.88 8.73-22.49 26.91-25.59 41.07.29.6.67 1.03 1.15 1.25 2.96 1.36 7.44-5.94 17.69-11.89Z"
          className="cls-ind61"
        />
        <path
          d="M1261.05 419.63c8.63 16.21 17.14 28.35 23.48 36.61 0 0 3.77 4.92 25.4 30.44-28.56 16.29-51.23 23.76-67.27 27.55-12.16 2.88-27.93 5.4-40.63 18.28-8.32 8.44-10.72 16.66-13.93 16.13-5.01-.82-6.19-21.86-1.02-41.05 5.16-19.18 15.51-32.17 25.1-43.97 9.5-11.69 25.15-28.33 48.86-43.98Z"
          className="cls-ind65"
        />
        <path
          d="M1202.05 532.5c12.7-12.88 28.46-15.4 40.63-18.28 16.03-3.79 38.71-11.26 67.27-27.55-21.63-25.52-25.4-30.44-25.4-30.44-6.34-8.26-14.85-20.41-23.48-36.61-.25.17-.5.34-.76.51-2.2 8.14-4.18 20.06-1.09 33.08 3.24 13.65 9.18 16.44 7.2 22.21-4.92 14.37-44.59 5.33-65.87 25.94-13.02 12.6-14.6 31.88-13.86 46.36.44.5.91.82 1.44.9 3.22.53 5.61-7.69 13.93-16.13Z"
          className="cls-ind62"
        />
        <path
          d="M1306.15 487.1c11.29 14.48 21.76 24.98 29.43 32.03 0 0 4.56 4.19 30.26 25.61-25.33 20.96-46.38 32.22-61.52 38.71-11.49 4.93-26.59 10.12-36.88 25-6.74 9.75-7.69 18.25-10.95 18.29-5.07.05-9.86-20.47-8.07-40.26 1.79-19.78 9.74-34.36 17.16-47.64 7.34-13.15 19.9-32.24 40.56-51.73Z"
          className="cls-ind64"
        />
        <path
          d="M1267.45 608.45c10.29-14.87 25.39-20.07 36.88-25 15.14-6.49 36.19-17.75 61.52-38.71-25.7-21.42-30.26-25.61-30.26-25.61-7.67-7.05-18.14-17.55-29.43-32.03l-.66.63c-.77 8.4-.66 20.48 4.62 32.78 5.54 12.89 11.87 14.62 10.92 20.64-2.38 15-43.01 12.92-60.43 36.88-10.66 14.66-8.9 33.92-5.67 48.06.52.42 1.04.65 1.57.64 3.26-.03 4.21-8.54 10.95-18.29Z"
          className="cls-ind61"
        />
        <path
          d="M1365.21 539.54c15.33 10.1 28.62 16.69 38.14 20.91 0 0 5.67 2.51 36.87 14.57-17.28 27.97-33.62 45.38-45.88 56.38-9.3 8.35-21.94 18.1-26.93 35.49-3.27 11.39-1.44 19.75-4.52 20.83-4.79 1.67-15.9-16.24-20.54-35.55-4.64-19.31-1.78-35.67 1-50.63 2.75-14.81 8.52-36.91 21.86-62Z"
          className="cls-ind65"
        />
        <path
          d="M1367.42 666.89c4.98-17.39 17.62-27.14 26.93-35.49 12.26-11 28.6-28.41 45.88-56.38-31.2-12.06-36.87-14.57-36.87-14.57-9.52-4.22-22.81-10.81-38.14-20.91l-.42.81c1.96 8.2 5.93 19.61 14.87 29.57 9.38 10.44 15.93 10.04 16.95 16.06 2.55 14.97-36.6 26.02-45.43 54.3-5.4 17.3 2.43 34.98 10.02 47.34.62.23 1.19.28 1.69.11 3.08-1.07 1.25-9.44 4.52-20.83Z"
          className="cls-ind62"
        />
        <path
          d="M1433.64 583.03c17.21 6.4 31.63 9.85 41.86 11.83 0 0 6.09 1.18 39.2 5.93-10.57 31.13-22.59 51.76-32.07 65.23-7.2 10.22-17.33 22.56-18.28 40.62-.63 11.83 3.03 19.57.27 21.31-4.29 2.7-19.13-12.26-27.99-30.04s-9.73-34.36-10.38-49.56c-.64-15.04.03-37.88 7.4-65.32Z"
          className="cls-ind64"
        />
        <path
          d="M1464.35 706.64c.96-18.06 11.09-30.4 18.28-40.62 9.48-13.47 21.5-34.1 32.07-65.23-33.11-4.76-39.2-5.93-39.2-5.93-10.23-1.98-24.65-5.42-41.86-11.83-.08.3-.15.59-.23.88 3.75 7.55 10.18 17.78 21.13 25.48 11.48 8.07 17.78 6.22 20.12 11.85 5.84 14.02-29.84 33.56-32.1 63.1-1.38 18.07 10.22 33.55 20.38 43.89.66.09 1.23 0 1.68-.28 2.76-1.74-.9-9.48-.27-21.31Z"
          className="cls-ind61"
        />
        <path
          d="M1515.07 597.57c18.07 3.23 32.88 4.05 43.3 4.17 0 0 6.2.07 39.63-1.16-4.85 32.52-12.99 54.96-19.92 69.91-5.26 11.34-13.02 25.29-10.74 43.23 1.49 11.76 6.47 18.72 4.07 20.92-3.74 3.43-21.01-8.65-32.9-24.57-11.89-15.92-15.7-32.07-19.05-46.91-3.32-14.69-6.73-37.28-4.37-65.6Z"
          className="cls-ind65"
        />
        <path
          d="M1567.33 713.72c-2.28-17.94 5.49-31.89 10.74-43.23 6.93-14.95 15.07-37.39 19.92-69.91-33.43 1.23-39.63 1.16-39.63 1.16-10.41-.12-25.22-.94-43.3-4.17-.03.3-.05.6-.07.91 5.04 6.76 13.19 15.68 25.33 21.3 12.73 5.89 18.6 2.95 21.91 8.07 8.25 12.75-23.37 38.35-20.33 67.81 1.86 18.02 16.04 31.19 27.88 39.55.66-.03 1.21-.21 1.6-.57 2.4-2.2-2.57-9.17-4.07-20.92Z"
          className="cls-ind62"
        />
        <path
          d="M1560.89 607.46c-53.34 0-135.36-11.85-210.69-71.4-44-34.78-77.65-79.28-100.02-132.27-15.33-36.33-21.64-67.95-24.23-88.08l16.84-2.17c5 38.82 26.49 136.91 117.94 209.2 100.55 79.48 213.72 69.44 246.01 64.47l2.58 16.78c-9.82 1.51-26.77 3.47-48.44 3.47Z"
          className="cls-ind63"
        />
        <path
          d="M761.36 342c-4.05 17.91-9.06 31.87-13 41.51 0 0-2.34 5.74-16.48 36.06 31.84 8.19 55.68 9.41 72.15 8.84 12.49-.43 28.37-2.16 44.01 6.92 10.25 5.95 14.73 13.24 17.69 11.89 4.61-2.11.21-22.72-9.83-39.87-10.04-17.14-23.44-26.94-35.81-35.8-12.24-8.77-31.73-20.7-58.73-29.55Z"
          className="cls-ind64"
        />
        <path
          d="M848.04 435.33c-15.64-9.08-31.52-7.35-44.01-6.92-16.46.57-40.3-.66-72.15-8.84 14.14-30.32 16.48-36.06 16.48-36.06 3.94-9.64 8.95-23.6 13-41.51.29.1.57.19.86.29 4.27 7.27 9.32 18.25 9.77 31.62.47 14.02-4.52 18.28-1.09 23.33 8.54 12.56 44.42-6.61 70.38 7.65 15.88 8.73 22.49 26.91 25.59 41.07-.29.6-.67 1.03-1.15 1.25-2.96 1.36-7.44-5.94-17.69-11.89Z"
          className="cls-ind61"
        />
        <path
          d="M738.95 419.63c-8.63 16.21-17.14 28.35-23.48 36.61 0 0-3.77 4.92-25.4 30.44 28.56 16.29 51.23 23.76 67.27 27.55 12.16 2.88 27.93 5.4 40.63 18.28 8.32 8.44 10.72 16.66 13.93 16.13 5.01-.82 6.19-21.86 1.02-41.05-5.16-19.18-15.51-32.17-25.1-43.97-9.5-11.69-25.15-28.33-48.86-43.98Z"
          className="cls-ind65"
        />
        <path
          d="M797.95 532.5c-12.7-12.88-28.46-15.4-40.63-18.28-16.03-3.79-38.71-11.26-67.27-27.55 21.63-25.52 25.4-30.44 25.4-30.44 6.34-8.26 14.85-20.41 23.48-36.61.25.17.5.34.76.51 2.2 8.14 4.18 20.06 1.09 33.08-3.24 13.65-9.18 16.44-7.2 22.21 4.92 14.37 44.59 5.33 65.87 25.94 13.02 12.6 14.6 31.88 13.86 46.36-.44.5-.91.82-1.44.9-3.22.53-5.61-7.69-13.93-16.13Z"
          className="cls-ind62"
        />
        <path
          d="M693.85 487.1c-11.29 14.48-21.76 24.98-29.43 32.03 0 0-4.56 4.19-30.26 25.61 25.33 20.96 46.38 32.22 61.52 38.71 11.49 4.93 26.59 10.12 36.88 25 6.74 9.75 7.69 18.25 10.95 18.29 5.07.05 9.86-20.47 8.07-40.26-1.79-19.78-9.74-34.36-17.16-47.64-7.34-13.15-19.9-32.24-40.56-51.73Z"
          className="cls-ind64"
        />
        <path
          d="M732.55 608.45c-10.29-14.87-25.39-20.07-36.88-25-15.14-6.49-36.19-17.75-61.52-38.71 25.7-21.42 30.26-25.61 30.26-25.61 7.67-7.05 18.14-17.55 29.43-32.03l.66.63c.77 8.4.66 20.48-4.62 32.78-5.54 12.89-11.87 14.62-10.92 20.64 2.38 15 43.01 12.92 60.43 36.88 10.66 14.66 8.9 33.92 5.67 48.06-.52.42-1.04.65-1.57.64-3.26-.03-4.21-8.54-10.95-18.29Z"
          className="cls-ind61"
        />
        <path
          d="M634.79 539.54c-15.33 10.1-28.62 16.69-38.14 20.91 0 0-5.67 2.51-36.87 14.57 17.28 27.97 33.62 45.38 45.88 56.38 9.3 8.35 21.94 18.1 26.93 35.49 3.27 11.39 1.44 19.75 4.52 20.83 4.79 1.67 15.9-16.24 20.54-35.55 4.64-19.31 1.78-35.67-1-50.63-2.75-14.81-8.52-36.91-21.86-62Z"
          className="cls-ind65"
        />
        <path
          d="M632.58 666.89c-4.98-17.39-17.62-27.14-26.93-35.49-12.26-11-28.6-28.41-45.88-56.38 31.2-12.06 36.87-14.57 36.87-14.57 9.52-4.22 22.81-10.81 38.14-20.91l.42.81c-1.96 8.2-5.93 19.61-14.87 29.57-9.38 10.44-15.93 10.04-16.95 16.06-2.55 14.97 36.6 26.02 45.43 54.3 5.4 17.3-2.43 34.98-10.02 47.34-.62.23-1.19.28-1.69.11-3.08-1.07-1.25-9.44-4.52-20.83Z"
          className="cls-ind62"
        />
        <path
          d="M566.36 583.03c-17.21 6.4-31.63 9.85-41.86 11.83 0 0-6.09 1.18-39.2 5.93 10.57 31.13 22.59 51.76 32.07 65.23 7.2 10.22 17.33 22.56 18.28 40.62.63 11.83-3.03 19.57-.27 21.31 4.29 2.7 19.13-12.26 27.99-30.04s9.73-34.36 10.38-49.56c.64-15.04-.03-37.88-7.4-65.32Z"
          className="cls-ind64"
        />
        <path
          d="M535.65 706.64c-.96-18.06-11.09-30.4-18.28-40.62-9.48-13.47-21.5-34.1-32.07-65.23 33.11-4.76 39.2-5.93 39.2-5.93 10.23-1.98 24.65-5.42 41.86-11.83.08.3.15.59.23.88-3.75 7.55-10.18 17.78-21.13 25.48-11.48 8.07-17.78 6.22-20.12 11.85-5.84 14.02 29.84 33.56 32.1 63.1 1.38 18.07-10.22 33.55-20.38 43.89-.66.09-1.23 0-1.68-.28-2.76-1.74.9-9.48.27-21.31Z"
          className="cls-ind61"
        />
        <path
          d="M484.93 597.57c-18.07 3.23-32.88 4.05-43.3 4.17 0 0-6.2.07-39.63-1.16 4.85 32.52 12.99 54.96 19.92 69.91 5.26 11.34 13.02 25.29 10.74 43.23-1.49 11.76-6.47 18.72-4.07 20.92 3.74 3.43 21.01-8.65 32.9-24.57 11.89-15.92 15.7-32.07 19.05-46.91 3.32-14.69 6.73-37.28 4.37-65.6Z"
          className="cls-ind65"
        />
        <path
          d="M432.67 713.72c2.28-17.94-5.49-31.89-10.74-43.23-6.93-14.95-15.07-37.39-19.92-69.91 33.43 1.23 39.63 1.16 39.63 1.16 10.41-.12 25.22-.94 43.3-4.17.03.3.05.6.07.91-5.04 6.76-13.19 15.68-25.33 21.3-12.73 5.89-18.6 2.95-21.91 8.07-8.25 12.75 23.37 38.35 20.33 67.81-1.86 18.02-16.04 31.19-27.88 39.55-.66-.03-1.21-.21-1.6-.57-2.4-2.2 2.57-9.17 4.07-20.92Z"
          className="cls-ind62"
        />
        <path
          d="M439.11 607.46c-21.67 0-38.61-1.96-48.44-3.47l2.58-16.78c32.29 4.97 145.47 15.01 246.01-64.47 91.44-72.28 112.94-170.38 117.94-209.2l16.84 2.17c-2.59 20.13-8.9 51.75-24.23 88.08-22.37 52.99-56.02 97.49-100.02 132.27-75.32 59.54-157.35 71.4-210.69 71.4Z"
          className="cls-ind63"
        />
        <path
          d="M1761.71 1250.31c76.76 23.71 112.33 50 163.98 31.82 17.77-6.26 31.62-15.73 40.06-22.26l21.69-144.88c-48.11 31.71-83.74 34.11-107.14 30.67-40.55-5.96-57.33-31.36-104.44-38.46-34.81-5.24-64.85 2.72-84.12 9.82l-16.89 112.78c37.31 6.24 66.99 14.38 86.85 20.51Z"
          className="cls-ind64"
        />
        <path
          d="M1904.54 1264.96c-59.22 4.92-85-38.18-151.29-44.96-17.5-1.79-44.17-1.7-78.38 9.8-7.15 47.77-14.31 95.54-21.46 143.3 17.4-8.71 45.03-19.47 77.61-17.43 48.58 3.05 67.22 31.99 111.92 39.58 23.05 3.92 58.38 3.07 106.17-24.19 6.42-42.91 12.85-85.81 19.27-128.72-13.81 8.65-36.29 20.31-63.84 22.6Z"
          className="cls-ind65"
        />
        <rect
          width={18.12}
          height={561.19}
          x={1637.32}
          y={1078.25}
          className="cls-ind64"
          rx={9.06}
          ry={9.06}
          transform="rotate(8.52 1645.635 1358.17)"
        />
        <path
          d="M1728.62 1107.39c-14.54 2.21-27.09 6.03-36.86 9.63l-16.89 112.78c2.27 1.42 8.7 4.96 17.29 3.12 9.95-2.13 16.16-10.02 17.87-12.35a19939.762 19939.762 0 0 1 18.59-113.18Z"
          className="cls-ind61"
        />
        <path
          d="M1903.25 1329.94c-60.63 10.14-84.92-55.2-149.12-44.04-10.97 1.91-24.69 6.33-34.8-3.54-12.76-12.46-12-40.13-9.49-61.12-5.22.79-10.77 1.85-16.61 3.25-6.55 1.57-12.68 3.38-18.36 5.31-7.15 47.77-14.31 95.54-21.46 143.3 17.4-8.71 45.03-19.47 77.61-17.43 48.58 3.05 67.22 31.99 111.92 39.58 23.05 3.92 58.38 3.07 106.17-24.19 3.57-23.82 7.13-47.63 10.7-71.45-23.9 21.75-43.72 28.17-56.55 30.32Z"
          className="cls-ind62"
        />
        <path
          d="M238.29 1250.31c-76.76 23.71-112.33 50-163.98 31.82-17.77-6.26-31.62-15.73-40.06-22.26l-21.69-144.88c48.11 31.71 83.74 34.11 107.14 30.67 40.55-5.96 57.33-31.36 104.44-38.46 34.81-5.24 64.85 2.72 84.12 9.82l16.89 112.78c-37.31 6.24-66.99 14.38-86.85 20.51Z"
          className="cls-ind64"
        />
        <path
          d="M95.46 1264.96c59.22 4.92 85-38.18 151.29-44.96 17.5-1.79 44.17-1.7 78.38 9.8 7.15 47.77 14.31 95.54 21.46 143.3-17.4-8.71-45.03-19.47-77.61-17.43-48.58 3.05-67.22 31.99-111.92 39.58-23.05 3.92-58.38 3.07-106.17-24.19-6.42-42.91-12.85-85.81-19.27-128.72 13.81 8.65 36.29 20.31 63.84 22.6Z"
          className="cls-ind65"
        />
        <rect
          width={18.12}
          height={561.19}
          x={344.56}
          y={1078.25}
          className="cls-ind64"
          rx={9.06}
          ry={9.06}
          transform="rotate(171.48 353.57 1358.865)"
        />
        <path
          d="M271.38 1107.39c14.54 2.21 27.09 6.03 36.86 9.63l16.89 112.78c-2.27 1.42-8.7 4.96-17.29 3.12-9.95-2.13-16.16-10.02-17.87-12.35a19939.762 19939.762 0 0 0-18.59-113.18Z"
          className="cls-ind61"
        />
        <path
          d="M96.75 1329.94c60.63 10.14 84.92-55.2 149.12-44.04 10.97 1.91 24.69 6.33 34.8-3.54 12.76-12.46 12-40.13 9.49-61.12 5.22.79 10.77 1.85 16.61 3.25 6.55 1.57 12.68 3.38 18.36 5.31 7.15 47.77 14.31 95.54 21.46 143.3-17.4-8.71-45.03-19.47-77.61-17.43-48.58 3.05-67.22 31.99-111.92 39.58-23.05 3.92-58.38 3.07-106.17-24.19-3.57-23.82-7.13-47.63-10.7-71.45 23.9 21.75 43.72 28.17 56.55 30.32Z"
          className="cls-ind62"
        />
        {children}
      </g>
    </svg>
  );
}
